import React from "react";
import { Form } from "react-bootstrap";
import CurrencyInput from "react-currency-input-field";

export default function InputNumber({
  label,
  name,
  onChangeMethod,
  onBlurMethod,
  value,
  error,
  touched,
  disabled,
  decimals,
  negatives,
  prefix,
  suffix,
  placeholder,
  disableSep,
  decimalsLimit = 2,
  maxLength,
  required,
}: {
  label: string;
  name: string;
  onChangeMethod: any;
  onBlurMethod: any;
  value: string;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  decimals?: boolean;
  negatives?: boolean;
  prefix?: string;
  suffix?: string;
  placeholder?: string;
  disableSep?: boolean;
  decimalsLimit?: number;
  maxLength?: number;
  required?: boolean;
}) {
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>
          {label} {required && <span className="text-danger">*</span>}
        </Form.Label>
        <CurrencyInput
          id={name}
          name={name}
          className={
            "form-control" +
            (error !== undefined && touched !== undefined ? " is-invalid" : "")
          }
          allowDecimals={decimals ? true : false}
          decimalsLimit={decimalsLimit}
          decimalScale={decimals ? (+value % 1 === 0 ? 0 : 2) : undefined}
          allowNegativeValue={negatives ? true : false}
          onValueChange={(value: any, name?: string) =>
            onChangeMethod({ target: { name: name, value: value } })
          }
          onBlur={onBlurMethod}
          value={value}
          prefix={prefix ? prefix : undefined}
          suffix={suffix ? suffix : undefined}
          groupSeparator=","
          decimalSeparator="."
          disabled={disabled ? true : false}
          disableGroupSeparators={disableSep ? true : false}
          placeholder={placeholder ? placeholder : undefined}
          maxLength={maxLength || 18}
        />
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
